import isUndefined from 'lodash/fp/isUndefined';
import { store } from '../../../configuration/setup/store';
import { selectIsSearchWidget } from '../../app/appSelectors';
import { type MapChargingStation, renderChargingPoints } from '../actions/renderChargingPoints';

export const RENDER_STATIONS_EVENT = 'EVENT_RENDER_STATIONS';

export type RenderStationsPayload = MapChargingStation[] | undefined;

export const renderStationsHandler = (data: RenderStationsPayload) => {
    const isSearchWidget = selectIsSearchWidget(store.getState());
    if (!isSearchWidget || isUndefined(data)) {
        return;
    }
    renderChargingPoints(data);
};
